import { atom } from 'recoil';

export const RequestDemoOpenState = atom<boolean>({
	key: 'request-demo-open-state',
	default: false,
});
